/**
 * The shop grid's standard look (the Prints mockup's grid: `.ggrid`, `.gtile`),
 * in theme tokens. A tile opens its product in the page's product window. A
 * studio that shows nothing draws nothing. Draws the behavior half's state and
 * calls its actions.
 */
import { partsOf, pieceRoot } from '../../contract/runtime';
import { contract } from './contract';
import type { ShopGridRuntime } from './useShopGrid';
import css from './ShopGrid.module.css';

const part = partsOf(contract);

export function ShopGridView({ state, actions }: ShopGridRuntime) {
  if (state.status !== 'ready') return null;
  return (
    <div className={css.grid} {...pieceRoot(contract)} {...part('grid')}>
      {state.products.map((p) => (
        <button key={p.handle} type="button" className={css.tile} onClick={() => actions.open(p.handle)} {...part('tile')}>
          <span className={css.face} {...part('image')}>
            {p.image && <img src={p.image.url} alt={p.image.alt} loading="lazy" />}
          </span>
          <span className={css.t} {...part('title')}>
            {p.title}
          </span>
          <span className={css.m} {...part('price')}>
            {p.prices}
          </span>
        </button>
      ))}
    </div>
  );
}
